/* eslint-disable */
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

// Create Context for Roles and Permissions
export const RolesPermissionsContext = createContext();

// Custom hook for consuming context easily
export const useRolesPermissionsContext = () => useContext(RolesPermissionsContext);

// Context Provider Component
export const RolesPermissionsProvider = ({ children }) => {
  const [roles, setRoles] = useState(() => {
    const storedRoles = sessionStorage.getItem('roles');
    return storedRoles ? JSON.parse(storedRoles) : [];
  });

  const [permissions, setPermissions] = useState(() => {
    const storedPermissions = sessionStorage.getItem('permissions');
    return storedPermissions ? JSON.parse(storedPermissions) : [];
  });

  useEffect(() => {
    // Persist roles and permissions to session storage
    sessionStorage.setItem('roles', JSON.stringify(roles));
    sessionStorage.setItem('permissions', JSON.stringify(permissions));
  }, [roles, permissions]);

  const value = useMemo(
    () => ({
      roles,
      setRoles,
      permissions,
      setPermissions,
    }),
    [roles, permissions],
  );

  return (
    <RolesPermissionsContext.Provider value={value}>{children}</RolesPermissionsContext.Provider>
  );
};

// Usage example in a component to set and get roles/permissions
/*
const Component = () => {
  const { roles, setRoles, permissions, setPermissions } = useRolesPermissionsContext();

  // Example to set roles and permissions (could be fetched from an API and then set)
  useEffect(() => {
    const fetchRolesAndPermissions = async () => {
      const rolesData = // fetch roles data from API
      const permissionsData = // fetch permissions data from API
      setRoles(rolesData);
      setPermissions(permissionsData);
    };

    fetchRolesAndPermissions();
  }, [setRoles, setPermissions]);

  return (
    <div>
      {/* Render your component that utilizes roles and permissions }
    </div>
  );
};
*/

// Make sure to wrap your app or the part of your app that needs access to roles/permissions with the provider
/*
import { RolesPermissionsProvider } from './path/to/your/context';

const App = () => {
  return (
    <RolesPermissionsProvider>
      <YourComponent />
    </RolesPermissionsProvider>
  );
};
*/

// This context and provider allow you to access and manipulate roles and permissions data throughout your application, with the changes being persistent across sessions thanks to sessionStorage.
